import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AppBar from "@mui/material/AppBar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { logoHeader } from "../../../assets/index";
import ListItemText from "@mui/material/ListItemText";
import { PRIMARY } from "../../../utils/constansColors";
import { Gap } from "../../atoms";
import "./header.css";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { getProvince } from "../../../config/Redux/Global/actions";
import { useDispatch } from "react-redux";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import Box from "@mui/material/Box";
import { Link, useLocation } from "react-router-dom";
import FolderIcon from "@mui/icons-material/Folder";
import ListItemButton from "@mui/material/ListItemButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";

const ResponsiveAppBar = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [excoExpanded, setExcoExpanded] = React.useState(true);

  let checkLevelExco = profile?.data?.id_tingkat_exco;
  let checkRoleLevelExco = profile?.data?.role;

  let levelExcoPusat =
    checkLevelExco === 1 &&
    (checkRoleLevelExco === 9 || checkRoleLevelExco === 1);
  let levelExcoProvinsi = checkLevelExco === 2 && checkRoleLevelExco === 9;
  let levelExcoKabKot = checkLevelExco === 3 && checkRoleLevelExco === 9;
  let levelExcoKecamatan = checkLevelExco === 4 && checkRoleLevelExco === 9;
  let levelExcoKelurahan = checkLevelExco === 5 && checkRoleLevelExco === 9;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    dispatch(getProvince());
  }, [dispatch]);

  const handleClose = (param) => {
    if (param === "profile") {
      navigate("/profil");
    }
    if (param === "logout") {
      localStorage.clear();
      navigate("/login");
    }
    setAnchorEl(null);
  };

  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
    });
    return has;
  };

  const getUserInitials = () => {
    const name = profile?.data?.name || "User";
    const names = name.split(" ");
    if (names.length >= 2) {
      return (names[0][0] + names[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const isExcoPath = [
    "/",
    "/provinsi",
    "/kab-kot",
    "/kecamatan",
    "/kelurahan",
    "/komisaris-basis",
  ].includes(path);

  const hasDocumentAccess =
    checkHakAkses(profile?.data?.hak_akses, "Document Admin Access") ||
    checkHakAkses(profile?.data?.hak_akses, "Document Manager Access") ||
    checkHakAkses(profile?.data?.hak_akses, "Document Viewer Only Access");

  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{
        backgroundColor: "#f5f5f5",
        marginLeft: "250px",
      }}
      sx={{
        "@media (max-width: 1200px)": {
          marginLeft: "0",
          width: "100%",
        },
      }}
    >
      <div style={{ marginLeft: "12px", marginRight: "12px" }}>
        <Toolbar disableGutters className="header-style">
          <div className="menu-bar">
            <MenuIcon onClick={() => setOpenDrawer(true)} />
            <Drawer
              anchor="left"
              open={Boolean(openDrawer)}
              onClose={() => setOpenDrawer(false)}
            >
              <Box sx={{ width: 270 }}>
                {/* Logo */}
                <div style={{ padding: "16px 20px" }}>
                  <img
                    style={{ height: "48px" }}
                    src={logoHeader}
                    alt="Partai Buruh"
                  />
                </div>

                <List component="nav" sx={{ padding: "0 8px" }}>
                  {/* Ikhtisar */}
                  {levelExcoPusat &&
                    checkHakAkses(
                      profile?.data?.hak_akses,
                      "Overview Access",
                    ) && (
                      <Link
                        to="/overview"
                        style={{ textDecoration: "none" }}
                        onClick={() => setOpenDrawer(false)}
                      >
                        <ListItemButton
                          sx={{
                            borderRadius: "8px",
                            mb: 0.5,
                            backgroundColor:
                              path === "/overview" ? "#fff5eb" : "transparent",
                            "&:hover": { backgroundColor: "#fff5eb" },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: "40px",
                              color:
                                path === "/overview" ? "#FF6801" : "#757575",
                            }}
                          >
                            <DashboardOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary="Ikhtisar"
                            primaryTypographyProps={{
                              fontSize: "14px",
                              fontWeight: path === "/overview" ? 600 : 400,
                              color:
                                path === "/overview" ? "#FF6801" : "#333333",
                            }}
                          />
                        </ListItemButton>
                      </Link>
                    )}

                  {/* Profil Partai */}
                  {levelExcoPusat && hasDocumentAccess && (
                    <Link
                      to="/"
                      style={{ textDecoration: "none" }}
                      onClick={() => setOpenDrawer(false)}
                    >
                      <ListItemButton
                        sx={{
                          borderRadius: "8px",
                          mb: 0.5,
                          backgroundColor:
                            path === "/" ? "#fff5eb" : "transparent",
                          "&:hover": { backgroundColor: "#fff5eb" },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: "40px",
                            color: path === "/" ? "#FF6801" : "#757575",
                          }}
                        >
                          <AccountBalanceOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary="Profil Partai"
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: path === "/" ? 600 : 400,
                            color: path === "/" ? "#FF6801" : "#333333",
                          }}
                        />
                      </ListItemButton>
                    </Link>
                  )}

                  {/* EXCO Group */}
                  {(levelExcoPusat ||
                    levelExcoProvinsi ||
                    levelExcoKabKot ||
                    levelExcoKecamatan ||
                    levelExcoKelurahan) &&
                    hasDocumentAccess && (
                      <>
                        <ListItemButton
                          onClick={() => setExcoExpanded(!excoExpanded)}
                          sx={{
                            borderRadius: "8px",
                            mb: 0.5,
                            backgroundColor:
                              isExcoPath && path !== "/"
                                ? "#fff5eb"
                                : "transparent",
                            "&:hover": { backgroundColor: "#fff5eb" },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: "40px",
                              color:
                                isExcoPath && path !== "/"
                                  ? "#FF6801"
                                  : "#757575",
                            }}
                          >
                            <FolderIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary="EXCO"
                            primaryTypographyProps={{
                              fontSize: "14px",
                              fontWeight:
                                isExcoPath && path !== "/" ? 600 : 400,
                              color:
                                isExcoPath && path !== "/"
                                  ? "#FF6801"
                                  : "#333333",
                            }}
                          />
                          {excoExpanded ? (
                            <ExpandLessIcon sx={{ color: "#757575" }} />
                          ) : (
                            <ExpandMoreIcon sx={{ color: "#757575" }} />
                          )}
                        </ListItemButton>

                        {excoExpanded && (
                          <List component="div" disablePadding sx={{ pl: 2 }}>
                            {(levelExcoPusat || levelExcoProvinsi) && (
                              <Link
                                to="/provinsi"
                                style={{ textDecoration: "none" }}
                                onClick={() => setOpenDrawer(false)}
                              >
                                <ListItemButton
                                  sx={{
                                    borderRadius: "8px",
                                    py: 0.75,
                                    backgroundColor:
                                      path === "/provinsi"
                                        ? "#fff5eb"
                                        : "transparent",
                                  }}
                                >
                                  <ListItemText
                                    primary="Provinsi"
                                    primaryTypographyProps={{
                                      fontSize: "13px",
                                      fontWeight:
                                        path === "/provinsi" ? 600 : 400,
                                      color:
                                        path === "/provinsi"
                                          ? "#FF6801"
                                          : "#757575",
                                      pl: 2,
                                    }}
                                  />
                                </ListItemButton>
                              </Link>
                            )}
                            {(levelExcoPusat ||
                              levelExcoProvinsi ||
                              levelExcoKabKot) && (
                              <Link
                                to="/kab-kot"
                                style={{ textDecoration: "none" }}
                                onClick={() => setOpenDrawer(false)}
                              >
                                <ListItemButton
                                  sx={{
                                    borderRadius: "8px",
                                    py: 0.75,
                                    backgroundColor:
                                      path === "/kab-kot"
                                        ? "#fff5eb"
                                        : "transparent",
                                  }}
                                >
                                  <ListItemText
                                    primary="Kab/Kota"
                                    primaryTypographyProps={{
                                      fontSize: "13px",
                                      fontWeight:
                                        path === "/kab-kot" ? 600 : 400,
                                      color:
                                        path === "/kab-kot"
                                          ? "#FF6801"
                                          : "#757575",
                                      pl: 2,
                                    }}
                                  />
                                </ListItemButton>
                              </Link>
                            )}
                            {(levelExcoPusat ||
                              levelExcoProvinsi ||
                              levelExcoKabKot ||
                              levelExcoKecamatan) && (
                              <Link
                                to="/kecamatan"
                                style={{ textDecoration: "none" }}
                                onClick={() => setOpenDrawer(false)}
                              >
                                <ListItemButton
                                  sx={{
                                    borderRadius: "8px",
                                    py: 0.75,
                                    backgroundColor:
                                      path === "/kecamatan"
                                        ? "#fff5eb"
                                        : "transparent",
                                  }}
                                >
                                  <ListItemText
                                    primary="Kecamatan"
                                    primaryTypographyProps={{
                                      fontSize: "13px",
                                      fontWeight:
                                        path === "/kecamatan" ? 600 : 400,
                                      color:
                                        path === "/kecamatan"
                                          ? "#FF6801"
                                          : "#757575",
                                      pl: 2,
                                    }}
                                  />
                                </ListItemButton>
                              </Link>
                            )}
                            {(levelExcoPusat ||
                              levelExcoProvinsi ||
                              levelExcoKabKot ||
                              levelExcoKecamatan ||
                              levelExcoKelurahan) && (
                              <Link
                                to="/kelurahan"
                                style={{ textDecoration: "none" }}
                                onClick={() => setOpenDrawer(false)}
                              >
                                <ListItemButton
                                  sx={{
                                    borderRadius: "8px",
                                    py: 0.75,
                                    backgroundColor:
                                      path === "/kelurahan"
                                        ? "#fff5eb"
                                        : "transparent",
                                  }}
                                >
                                  <ListItemText
                                    primary="Kelurahan/Desa"
                                    primaryTypographyProps={{
                                      fontSize: "13px",
                                      fontWeight:
                                        path === "/kelurahan" ? 600 : 400,
                                      color:
                                        path === "/kelurahan"
                                          ? "#FF6801"
                                          : "#757575",
                                      pl: 2,
                                    }}
                                  />
                                </ListItemButton>
                              </Link>
                            )}
                            {levelExcoPusat && (
                              <Link
                                to="/komisaris-basis"
                                style={{ textDecoration: "none" }}
                                onClick={() => setOpenDrawer(false)}
                              >
                                <ListItemButton
                                  sx={{
                                    borderRadius: "8px",
                                    py: 0.75,
                                    backgroundColor:
                                      path === "/komisaris-basis"
                                        ? "#fff5eb"
                                        : "transparent",
                                  }}
                                >
                                  <ListItemText
                                    primary="Komisaris Basis"
                                    primaryTypographyProps={{
                                      fontSize: "13px",
                                      fontWeight:
                                        path === "/komisaris-basis" ? 600 : 400,
                                      color:
                                        path === "/komisaris-basis"
                                          ? "#FF6801"
                                          : "#757575",
                                      pl: 2,
                                    }}
                                  />
                                </ListItemButton>
                              </Link>
                            )}
                          </List>
                        )}
                      </>
                    )}

                  {/* Pengaturan Pengguna */}
                  {levelExcoPusat &&
                    checkHakAkses(
                      profile?.data?.hak_akses,
                      "User Management Access",
                    ) && (
                      <Link
                        to="/user-management"
                        style={{ textDecoration: "none" }}
                        onClick={() => setOpenDrawer(false)}
                      >
                        <ListItemButton
                          sx={{
                            borderRadius: "8px",
                            mb: 0.5,
                            backgroundColor:
                              path === "/user-management"
                                ? "#fff5eb"
                                : "transparent",
                            "&:hover": { backgroundColor: "#fff5eb" },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: "40px",
                              color:
                                path === "/user-management"
                                  ? "#FF6801"
                                  : "#757575",
                            }}
                          >
                            <PeopleOutlineIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary="Pengaturan Pengguna"
                            primaryTypographyProps={{
                              fontSize: "14px",
                              fontWeight:
                                path === "/user-management" ? 600 : 400,
                              color:
                                path === "/user-management"
                                  ? "#FF6801"
                                  : "#333333",
                            }}
                          />
                        </ListItemButton>
                      </Link>
                    )}
                </List>
              </Box>
            </Drawer>
          </div>

          {/* User Profile Section */}
          <div className="header-user-section" onClick={handleClick}>
            <p className="header-user-name">{profile?.data?.name || "Admin"}</p>
            <div className="header-user-avatar">{getUserInitials()}</div>
            <KeyboardArrowDownIcon style={{ color: "#757575" }} />
          </div>

          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            onClick={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={() => handleClose("profile")}>Profil</MenuItem>
            <MenuItem onClick={() => handleClose("logout")}>Keluar</MenuItem>
          </Menu>
        </Toolbar>
      </div>
    </AppBar>
  );
};
export default ResponsiveAppBar;
